import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { TimeCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import { TimesheetEditDialogComponent } from 'projects/desktop/src/app/modules/timesheets/view/timesheet-edit-dialog/timesheet-edit-dialog.component';
import { TimeCardService } from '../../../data/time-card.service';
import { TimeCardsQuery } from '../../../data/time-cards.query';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { debounceTime } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { merge, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
	selector: 'app-timesheet',
	templateUrl: './timesheet.component.html',
	styleUrls: ['./timesheet.component.scss']
})
@RxJSUnsubscribe
export class TimesheetComponent implements OnInit, OnDestroy, OnChanges, RxJSUnsubscribable {

	@Input()
	startPeriod: string;

	@Input()
	endPeriod: string;

	timeCards: TimeCard[];

	timeCardsMap = new Map<string, TimeCard[]>();

	sheetLoading = true;

	mergeSub: Subscription;

	constructor(
		protected timeCardService: TimeCardService,
		protected timeCardsQuery: TimeCardsQuery,
		protected dialog: MatDialog
	) { }

	ngOnInit() {
		this.mergeSub = merge(this.timeCardsQuery.todayCards, this.timeCardsQuery.lastTimeCard)
			.pipe(
				debounceTime(250),
				takeUntil(this.getUnsubFromAllSubs())
			)
			.subscribe(emit => {
				this.getCards();
			})
	}

	returnZero() {
		return 0
	}

	getCards() {
		this.timeCardService.getCards(this.startPeriod, this.endPeriod).subscribe(timecards => {
			this.timeCardsMap.clear();
			timecards.forEach(timecard => {
				const key = moment(timecard.startTime).format('L')
				if (!this.timeCardsMap.has(key)) {
					this.timeCardsMap.set(key, [])
				}
				this.timeCardsMap.get(key).push(timecard)
			})
			this.sheetLoading = false;
		})
	}

	addSheet() {
		const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
			data: { buttonLabel: 'Add' },
			disableClose: true,
			panelClass: 'time-sheet-edit-dialog'
		});

		dialogRef.afterClosed().subscribe(result => {
			this.getCards();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		// tslint:disable-next-line: no-string-literal
		if (changes['startPeriod'] || changes['endPeriod']) {

			this.sheetLoading = true;
			this.getCards()
		}
	}


	openSheetDialog(timeCard) {
		const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
			data: { timeCard, buttonLabel: 'Save' },
			disableClose: true,
			panelClass: 'time-sheet-edit-dialog'
		});

		dialogRef.afterClosed().subscribe(result => {
			this.getCards();
		});
	}

	print() {
	}

	getDuration(date: string) {
		let duration = 0;
		let durationString = '';

		this.timeCardsMap.get(date).forEach(card => {
			if (card.type !== 'UNPAID_BREAK') {
				duration += card.duration
			}
		})

		const hours = Math.trunc(duration / 60)
		const minutes = Math.trunc(duration - hours * 60)
		durationString = hours + 'h ' + minutes + 'm'
		return durationString


	}

	getDurationTime(time: number) {
		const totalHours = Math.trunc(time / 60)
		const totalMinutes = Math.trunc(time - totalHours * 60)
		const totalTime = totalHours + 'h ' + totalMinutes + 'm'
		return totalTime
	}

	ngOnDestroy() {
		this.mergeSub.unsubscribe()
	}

	getUnsubFromAllSubs(): Subject<boolean> {
		return null
	}

}
